import { useMutation } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'
import type { CreateSupportRequestInput } from '@fellowship/shared'

export function useSupportRequest() {
  return useMutation({
    mutationFn: (input: CreateSupportRequestInput) =>
      apiFetch<{ data: { id: string } }>('/support-requests', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
  })
}
